import { useState, useEffect } from 'react';
import {auth} from "../firebase";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

function useLogin() {
    const [isOnline, setIsOnline] = useState(null);
    const provider = new GoogleAuthProvider();
    // Sign In Pop up initiator
    const signInFunction = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                // The signed-in user info.
                const user = result.user;
                return user;
                // ...
            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = GoogleAuthProvider.credentialFromError(error);
                // ...
            });
    }
    useEffect(() => {
        setIsOnline(signInFunction())
    }, [isOnline]);

    return isOnline;
}

export default useLogin;